import React from 'react';
import useBreakpoint from '~/hooks/useBreakpoint';

const PageLayout = ({
  children,
  className = '',
  bodyClassName = '',
  title,
  subTitle,
  ctas,
}: {
  children: React.ReactNode;
  className?: string;
  bodyClassName?: string;
  title: string;
  subTitle?: string | React.ReactNode;
  ctas?: React.ReactNode;
}) => {
  const { mdScreen } = useBreakpoint();

  return (
    <div
      className={`w-full page-layout  ${mdScreen ? 'container' : ''} ${className}`}
    >
      <div className="flex flex-col gap-4x w-full">
        <div className="flex justify-between w-full ">
          <div className="flex flex-col gap-x w-full">
            <div className="flex justify-between">
              <p className="text-title_3 text-black">{title}</p>
              {ctas}
            </div>
            {subTitle && (
              <p className="text-body_1 text-gray__dark_1 ">{subTitle}</p>
            )}
          </div>
        </div>
        <div
          className={`flex flex-col w-full page-layout-body ${bodyClassName}`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageLayout;
